module.exports = __webpack_public_path__ + "img/tiankong.f2e7faa0.png";